var _style, _g, _path, _path2, _path3, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEasterGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85 85",
    style: {
      enableBackground: "new 0 0 85 85"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CCCCCC;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 42.5,
    cy: 42.5,
    r: 42.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-67.1-5.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-39.4-24.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-28.2-24.2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.5,18.4c-4.2,0-8.9,2.7-12.5,7.2c-3.8,4.8-6,10.8-6,16.9c0,19.1,12.1,24.1,18.4,24.1 c6.4,0,18.4-5,18.4-24.1C60.9,31.4,52.9,18.4,42.5,18.4z M42.5,20.7c6.1,0,13.1,6.5,15.4,15.6H27.2C29.5,28.3,35.6,20.7,42.5,20.7z  M58.6,42.5c0,2.1-0.2,4-0.4,5.7H26.9c-0.4-2.1-0.6-4.1-0.6-5.7c0-1.3,0.1-2.6,0.4-3.9h31.6C58.5,39.9,58.6,41.2,58.6,42.5z  M42.5,64.3c-8.9,0-13.3-7-15.1-13.8h30.3C55,61.2,47.1,64.3,42.5,64.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 31.9,
    cy: 43,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 42.3,
    cy: 43,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 53.1,
    cy: 43,
    r: 2.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasterGrey);
export default __webpack_public_path__ + "static/media/EasterGrey.6f43b356f7eddf3a490318196e66e43b.svg";
export { ForwardRef as ReactComponent };